var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.randomId}},[_c('ejs-listview',{ref:"listNe",attrs:{"id":"flat-list","dataSource":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }